<template lang="pug">
  #main
    .container
      h1.display-4.py-2 BC Scanner (Alpha Version)
      a(href="#/scanner") Scanner
</template>

<script>
export default {
  name: "Home"
};
</script>

<style>
</style>